import { render } from "./odn-modal-config.vue?vue&type=template&id=a012fcf6"
import script from "./odn-modal-config.vue?vue&type=script&lang=js"
export * from "./odn-modal-config.vue?vue&type=script&lang=js"

import exportComponent from "/oudini/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__